
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choose-plan",
      function () {
        return require("private-next-pages/choose-plan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/choose-plan"])
      });
    }
  